import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Edit from '@hellodarwin/icons/dist/icons/Edit';
import { useEffect, useRef, useState } from 'react';
import { SortedTableEditableCellContent, SortedTableEditableCellEditor, SortedTableEditableCellRoot, } from './styles';
const EditableSortedTableCell = ({ row, editableConfig, children, }) => {
    var _a, _b;
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [value, setValue] = useState();
    const inputRef = useRef(null);
    const isEditable = (_b = (_a = editableConfig === null || editableConfig === void 0 ? void 0 : editableConfig.isEditable) === null || _a === void 0 ? void 0 : _a.call(editableConfig, row)) !== null && _b !== void 0 ? _b : !!editableConfig;
    useEffect(() => {
        var _a, _b;
        if (editing) {
            (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [editing]);
    const enterEditMode = () => {
        if (!editableConfig || saving)
            return;
        setValue(editableConfig.getValue(row));
        setEditing(true);
    };
    const cancel = () => {
        setEditing(false);
    };
    const save = async (nextValue = value) => {
        if (!editableConfig)
            return;
        setSaving(true);
        try {
            await editableConfig.onSave(row, nextValue);
            setEditing(false);
        }
        finally {
            setSaving(false);
        }
    };
    if (!isEditable || !editableConfig) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(SortedTableEditableCellRoot, { onClick: (event) => {
            event.stopPropagation();
            if (!editing)
                enterEditMode();
        }, onDoubleClick: (event) => event.stopPropagation(), children: editing ? (_jsx(SortedTableEditableCellEditor, { children: editableConfig.editor({
                value: value,
                onChange: setValue,
                save,
                cancel,
                row,
                inputRef,
            }) })) : (_jsxs(SortedTableEditableCellContent, { children: [_jsx("span", { children: children }), _jsx(Edit, { size: 14 })] })) }));
};
export default EditableSortedTableCell;
